var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rule",class:_vm.className},[_c('b-icon',{attrs:{"icon":_vm.icon,"scale":_vm.scale}}),_vm._v(" "+_vm._s(_vm.message)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }